<template>
  <div>
    <!-- <modal :show.sync="handleviewmodal" hide-footer>
      <h6 slot="header" class="modal-title text-white pt-1">View Artworks</h6>
      <Viewartworks />
    </modal> -->
    <b-card class="border-none">
      <!-- <modal :show.sync="editModal" header-classes="bg-primary p-3">
        <h6 slot="header" class="modal-title text-white font-semibold pt-1">
          EDIT IMAGE ORDER
        </h6>

        <template slot="footer">
          <base-button type="primary">SAVE CHANGES</base-button>
          <base-button
            type="secondary"
            class="ml-auto"
            @click="editModal = false"
            >CLOSE</base-button
          >
        </template>
      </modal> -->

      <div class="flex justify-between items-center mb-8">
        <div>
          <h2 class="text-2xl font-semibold">Artworks</h2>
        </div>
        <div class="flex">
          <div>
            <base-button
              outline
              class="px-6 py-1 mx-1"
              type="primary"
              v-b-modal.modal-6
            >
              <span class="btn-inner--text flex justify-between items-center"
                ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon
                >Artworks</span
              >
            </base-button>

            <b-modal id="modal-6" title="Add Artworks" hide-footer>
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <b-form
                  role="form"
                  @submit.prevent="handleSubmit(handleCreate)"
                >
                  <div class="">
                    <div class="">
                      <p class="input-title textcolor">Type of Art</p>
                      <b-form-select
                        v-model="art"
                        placeholder="Select Artwork"
                        class="md:border-0 lg:border-0 custipshadow"
                        name="city"
                      >
                        <b-form-select-option :value="null" class="textcolor"
                          >Please select an option</b-form-select-option
                        >
                        <b-form-select-option value="Poetry" class="textcolor"
                          >Poetry</b-form-select-option
                        >
                        <b-form-select-option value="Photo" class="textcolor"
                          >Photo</b-form-select-option
                        >
                        <b-form-select-option value="Video" class="textcolor"
                          >Video</b-form-select-option
                        >
                        <b-form-select-option value="Prose" class="textcolor"
                          >Prose</b-form-select-option
                        >
                      </b-form-select>
                    </div>

                    <div
                      class="lg:mt-6 md:mt-6 mt-6"
                      v-if="
                        art === 'Photo' || art === 'Poetry' || art === 'Prose'
                      "
                    >
                      <p class="input-title textcolor">Photo</p>
                      <!-- <el-upload
                        class="upload-demo"
                        :auto-upload="false"
                        action="#"
                        list-type="picture-card"
                        accept="image/*"
                        multiple
                        :on-change="handleImageChange"
                        :on-remove="handleImageRemove"
                        :before-upload="beforeUpload"
                        :limit="1"
                      >
                        <i slot="default" class="el-icon-plus"></i>
                      </el-upload> -->
                      <div class="grid grid-cols-2 gap-6">
                        <div
                          class="relative cursor-pointer bg-fa dash-primary w-full h-40 rounded-lg overflow-hidden flex items-center justify-center"
                        >
                          <div v-if="!imagePreview">
                            <p class="fsize14 text-center text-gray">
                              Upload Here
                            </p>
                          </div>
                          <input
                            type="file"
                            class="uploads absolute top-0 left-0 w-full h-40 opacity-0 cursor-pointer"
                            accept="image/*"
                            @change="handleImageUpload"
                          />
                        </div>

                        <div v-if="imagePreview" class="relative">
                          <img
                            :src="imagePreview"
                            alt="Uploaded"
                            class="w-full h-40 object-cover rounded-lg"
                          />
                          <div class="absolute top-0 right-0 m-1">
                            <div
                              class="w-6 h-6 rounded-full flex items-center justify-center bg-white cursor-pointer"
                              @click="removeImage"
                            >
                              <feather-icon
                                icon="XIcon"
                                svgClasses="w-4 h-4"
                                class="flex text-primary"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="
                        art === 'Video' || art === 'Poetry' || art === 'Prose'
                      "
                      class="pt-3"
                    >
                      <div>
                        <p class="input-title textcolor">Video</p>
                        <el-upload
                          class="upload-demo"
                          :auto-upload="false"
                          action="#"
                          accept="video/mp4,video/x-m4v,video/*"
                          :on-change="handleVideoChange"
                          :on-remove="handleVideoRemove"
                        >
                          <b-button
                            variant="primary"
                            class="md:px-10 lg:px-10 px-6 md:py-3 lg:py-3 py-1 border-2 text-base font-bold flex m-auto"
                            >Upload Video</b-button
                          >
                        </el-upload>
                        <video
                          controls
                          v-show="video"
                          :src="renderedImage"
                        ></video>
                      </div>
                      <div class="pt-3">OR</div>
                      <div class="pt-3">
                        <p class="input-title textcolor">Video URL</p>
                        <base-input
                          v-model="videoUrl"
                          placeholder="Enter your Video Url"
                          class="md:border-0 lg:border-0 custipshadow"
                          name="videoUrl"
                          :rules="{}"
                        ></base-input>
                      </div>
                    </div>

                    <div class="">
                      <p class="input-title textcolor">First Name</p>
                      <base-input
                        v-model="firstName"
                        placeholder="Enter your First Name"
                        class="md:border-0 lg:border-0 custipshadow"
                        name="First Name"
                        :rules="{ required: true, regex: /^[A-Za-z\s]+$/ }"
                        @input="
                          firstName = firstName
                            .replace(/[^A-Za-z\s]/g, '')
                            .replace(/\s{2,}/g, ' ')
                        "
                      ></base-input>
                    </div>
                    <div class="">
                      <p class="input-title textcolor">Last Name</p>
                      <base-input
                        v-model="lastName"
                        placeholder="Enter your Last Name"
                        class="md:border-0 lg:border-0 custipshadow"
                        name="Last Name"
                        :rules="{ required: true, regex: /^[A-Za-z\s]+$/ }"
                        @input="
                          lastName = lastName
                            .replace(/[^A-Za-z\s]/g, '')
                            .replace(/\s{2,}/g, ' ')
                        "
                      ></base-input>
                    </div>

                    <div class="">
                      <p class="input-title textcolor">Mobile No.</p>
                      <base-input
                        v-model="mobile"
                        placeholder="Enter your Mobile No."
                        class="md:border-0 lg:border-0 custipshadow"
                        name="Mobile No."
                        :rules="{ required: true, regex: /^[0-9]{10}$/ }"
                        @input="mobile = mobile.replace(/\D/g, '').slice(0, 10)"
                      ></base-input>
                    </div>

                    <div class="">
                      <p class="input-title textcolor">Email Address</p>
                      <base-input
                        v-model="email"
                        placeholder="Enter your EmailID"
                        class="md:border-0 lg:border-0 custipshadow"
                        name="Email"
                        :rules="{ required: true, email: true }"
                        @input="email = email.toLowerCase()"
                      ></base-input>
                    </div>

                    <div class="pt-3" v-if="art === 'Poetry'">
                      <p class="input-title textcolor">Poetry Heading</p>
                      <base-input
                        v-model="poetryHeading"
                        placeholder="Enter your poetry heading"
                        class="md:border-0 lg:border-0 custipshadow"
                        name="Poetry Heading"
                        :rules="{ required: true }"
                      ></base-input>
                    </div>

                    <div class="md:mb-0 lg:mb-0 mb-9">
                      <p class="input-title textcolor">Message</p>

                      <quill-editor
                        v-model="message"
                        :options="editorOption"
                        class="quill-h200px my-2 bg-white"
                      />
                    </div>

                    <div class="flex justify-center">
                      <b-button type="submit" variant="primary">Save</b-button>
                    </div>
                  </div>
                </b-form>
              </validation-observer>
            </b-modal>
          </div>
        </div>
      </div>

      <b-input-group class="mt-12">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          v-model="search"
          placeholder="Enter Search...."
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
          >
            <feather-icon
              class="cursor-pointer mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>

      <el-table
        :data="tableData"
        style="width: 100%"
        class="mt-4 rounded"
        header-row-class-name="thead-light table-th-color "
      >
        <el-table-column
          label="Sr. No"
          type="index"
          :index="indexMethod"
          width="80px"
        ></el-table-column>
        <el-table-column prop="name" label="Name" width="">
          <template v-slot="{ row }">
            {{ row.firstName }} {{ row.lastName }}
          </template>
        </el-table-column>
        <el-table-column prop="art" label="Type of artwork" width="">
        </el-table-column>
        <el-table-column prop="status" label="Status" width="">
          <template v-slot="{ row }">
            <div
              class="flex gap-2"
              v-if="
                row.status === null ||
                row.status === 'Pending' ||
                row.status === undefined
              "
            >
              <div>
                <feather-icon
                  icon="CheckIcon"
                  class="border-none rounded-sm text-success cursor-pointer"
                  @click="handleStatus('Approved', row)"
                />
              </div>
              <div>
                <feather-icon
                  icon="XIcon"
                  class="border-none rounded-sm text-danger cursor-pointer"
                  @click="handleStatus('Rejected', row)"
                />
              </div>
            </div>
            <div class="flex gap-2" v-else>
              <div
                :class="
                  row.status === 'Approved' ? 'text-success' : 'text-danger'
                "
              >
                {{ row.status }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="action" label="Action" width="100">
          <template v-slot="{ row }">
            <div class="flex items-center justify-end">
              <feather-icon
                icon="EyeIcon"
                svgClasses="w-5 h-5"
                class="cursor-pointer textcolor"
                @click="handleViewmodal(row, true)"
                v-b-modal.handleviewmodal
              />
              <feather-icon
                v-if="row.isAdmin"
                icon="EditIcon"
                svgClasses="w-5 h-5"
                class="ml-2 cursor-pointer textcolor"
                @click="handleEditModal(row, true)"
                v-b-modal.modal-2
              />
              <feather-icon
                svgClasses="w-5 h-5"
                class="ml-2 cursor-pointer text-danger"
                icon="Trash2Icon"
                @click="handleDelete(row._id)"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>
      <b-modal id="modal-2" title="Edit Artworks" hide-footer>
        <div>
          <EditArtworks
            @getShareWork="getShareWork"
            @closeModal="closeModal('modal-2')"
            :editData="editData"
          />
          <!-- :editModal="editModal" -->
        </div>
      </b-modal>

      <b-modal id="handleviewmodal" title="View Artworks" hide-footer>
        <div>
          <Viewartworks
            @getShareWork="getShareWork"
            @closeModal="closeModal('handleviewmodal')"
            :editData="editData"
          />
        </div>
      </b-modal>
      <b-card-footer class="py-4 d-flex justify-content-end">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="my-table"
        ></b-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>
<script>
import _ from "lodash";
import { mapState } from "vuex";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
// import FileUploader from "@/components/FileUploader.vue";
import { Upload } from "element-ui";
import EditArtworks from "./components/EditArtworks.vue";
import Viewartworks from "./components/Viewartworks.vue";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";

export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    // FileUploader,
    quillEditor,
    [Upload.name]: Upload,
    EditArtworks,
    Viewartworks,
  },
  data() {
    return {
      currentPage: 1,
      handleviewmodal: false,
      perPage: 10,
      totalRows: 0,
      search: "",
      poetryHeading: "",
      selectedFile: null,
      imagePreview: null,
      editModal: false,
      openAddBannerSidebar: false,
      approve: false,
      tableData: [],
      srno: "",
      name: "",
      typeofartwork: "",
      status: "",
      artworks: "",
      editData: {},

      view: {},
      art: null,
      firstName: "",
      lastName: "",
      email: "",
      mobile: "",
      message: "",
      videoUrl: "",
      video: null,
      images: [],
      artWorkPermission: false,

      editorOption: {
        theme: "snow",
      },
      renderedImage: null,
    };
  },
  watch: {
    async currentPage() {
      await this.getShareWork();
    },
    search: {
      handler: _.debounce(async function (val) {
        this.getShareWork();
      }, 500),
    },
  },
  methods: {
    beforeUpload(file) {
      if (this.fileListImage.length >= 1) {
        this.$message.warning("You can only upload one image");
        return false;
      }
      return true;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
    handleEditModal(row, modal = false) {
      this.editModal = modal;
      this.editData = row;
      // console.log(row);
      // console.log(this.editModal);
    },
    handleViewmodal(row, modal = false) {
      this.editModal = modal;
      this.editData = row;
    },
    indexMethod(index) {
      return this.perPage * (this.currentPage - 1) + index + 1;
    },

    //add
    handleVideoChange(file, fileList) {
      let mByte = 5 * 1048576;
      if (file.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        fileList.pop();
        return;
      }
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
      // this.video = fileList[0].raw;
      if (!fileList[0].raw.type.includes("video")) {
        this.$swal.fire({
          text: `Please Select Video only !`,
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        this.handleVideoRemove(file, fileList);
      } else {
        this.video = fileList[0].raw;
        this.readerData(this.video);
      }
      // console.log(this.video);
    },
    handleVideoRemove(file, fileList) {
      const index = fileList.indexOf(file);
      fileList.splice(index, 1);
      this.video = null;
    },

    handleImageChange(file, fileList) {
      let mByte = 5 * 1048576;
      if (file.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        fileList.pop();
        return;
      } else {
        this.images = fileList.map((data) => data.raw);
      }
    },
    handleImageRemove(file, fileList) {
      console.log(file);
      fileList = fileList.filter((item) => item.uid !== file.uid);
      this.images = fileList.map((data) => data.raw);
      // console.log(fileList);
    },
    resetForm() {
      this.art = null;
      this.firstName = "";
      this.lastName = "";
      this.email = "";
      this.mobile = "";
      this.message = "";
      this.videoUrl = "";
      this.video = null;
      this.images = [];
      this.artWorkPermission = false;
      this.poetryHeading = "";
      this.renderedImage = null;
      this.selectedFile = null;
      this.imagePreview = null;
    },
    sortArtworks(list) {
      return [...(list || [])].sort((a, b) => {
        const timeA = new Date(a.createdAt || 0).getTime();
        const timeB = new Date(b.createdAt || 0).getTime();
        if (timeB !== timeA) return timeB - timeA;
        return String(b._id || "").localeCompare(String(a._id || ""));
      });
    },
    showApiError(error, fallback) {
      const message =
        (error &&
          error.response &&
          error.response.data &&
          (error.response.data.message || error.response.data.error)) ||
        fallback;
      this.$swal.fire({
        text: message,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#830c81",
        showCancelButton: false,
      });
    },
    async handleStatus(status, artwork) {
      let FormData = require("form-data");
      let data = new FormData();
      data.append("shareWorkId", artwork._id);
      data.append("status", status);

      let loader = this.$loading();

      try {
        const shareWorkData = await this.$store.dispatch(
          "hoc/updateSharework",
          data
        );
        if (shareWorkData.code == 200) {
          // this.$router.push({ name: "blogs" });
          this.getShareWork();
          this.$swal.fire({
            text: `ArtWork ${status}`,
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
          console.log(error);
        }
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.renderedImage = e.target.result));
        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      const mByte = 5 * 1048576; // 5 MB
      if (file.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });

        const fileInput = document.querySelector(".uploads");
        if (fileInput) fileInput.value = "";

        return;
      }
      this.selectedFile = file;

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imagePreview = reader.result;
      };
    },

    removeImage() {
      this.selectedFile = null;
      this.imagePreview = null;

      const fileInput = document.querySelector(".uploads");
      if (fileInput) {
        fileInput.value = "";
      }
    },
    async handleCreate() {
      // console.log(this.video);
      let imgFlag = false;
      this.images.forEach((ele) => {
        if (!ele.type.includes("image")) {
          imgFlag = true;
        }
      });
      if (imgFlag) {
        this.$swal.fire({
          text: `Please Select Image only in Photos!`,
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      if (this.art === null) {
        this.$swal.fire({
          text: `Please Select Art!`,
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      if (this.art === "Poetry" && this.message === "") {
        this.$swal.fire({
          text: `Please Enter Message!`,
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }

      let FormData = require("form-data");
      let data = new FormData();
      data.append("firstName", this.firstName);
      if (this.lastName) data.append("lastName", this.lastName);
      if (this.email) data.append("email", this.email);
      if (this.mobile) data.append("mobile", this.mobile);
      // data.append("city", this.city);
      data.append("art", this.art);
      if (this.message) data.append("message", this.message);
      data.append("userId", this.user._id);
      data.append("isAdmin", JSON.stringify(true));
      data.append("status", "Approved");
      if (this.video) data.append("video", this.video);
      if (this.videoUrl) data.append("videoUrl", this.videoUrl);
      if (this.poetryHeading) data.append("poetryHeading", this.poetryHeading);

      if (this.selectedFile) {
        data.append("images", this.selectedFile);
      }
      // console.log(this.images);
      data.append("artWorkPermission", true);

      let loader = this.$loading();

      if (this.art === "Video" && this.video === null && this.videoUrl === "") {
        this.$swal.fire({
          text: "Please Select Video or Video Url",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        return;
      }

      if (this.art === "Photo" && !this.selectedFile) {
        this.$swal.fire({
          text: "Please Select image",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        return;
      }
      // console.log([...data]);
      try {
        const shareWorkData = await this.$store.dispatch(
          "hoc/createSharework",
          data
        );

        if (shareWorkData && shareWorkData.code == 200) {
          this.closeModal("modal-6");
          this.getShareWork();
          this.$swal.fire({
            text: "ArtWork Added Successfully",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          this.resetForm();
        } else {
          this.showApiError(
            null,
            (shareWorkData && shareWorkData.message) ||
              "Unable to add artwork. Please try again."
          );
        }

        loader.close();
      } catch (error) {
        loader.close();
        this.showApiError(error, "Unable to add artwork. Please try again.");
      }
    },

    //delete
    async handleDelete(data) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(data);
      }
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData(id) {
      let loader;
      let payload = {
        shareWorkId: id,
      };
      loader = this.$loading();
      try {
        const data = await this.$store.dispatch("hoc/deleteSharework", payload);
        loader.close();
        if (data && data.code === 200) {
          this.getShareWork();
          await this.$swal({
            text: "ArtWork Deleted successfully",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
        }
      } catch (err) {
        console.log(err);
        loader.close();
      }
    },

    closeModal(modal) {
      this.$nextTick(() => {
        this.$bvModal.hide(modal);
      });
    },

    async getShareWork() {
      let curPage = this.currentPage - 1;
      let payload = {
        limit: this.perPage,
        offset: curPage,
      };
      let loader;
      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });

      try {
        loader = this.$loading();
        const getShareWork = await this.$store.dispatch(
          "hoc/getSharework",
          payload
        );
        // console.log(getShareWork);
        loader.close();
        this.totalRows =
          this.shareWork && this.shareWork.totalCount
            ? this.shareWork.totalCount
            : 0;
        this.tableData = this.sortArtworks(
          this.shareWork && this.shareWork.result ? this.shareWork.result : []
        );
      } catch (error) {
        console.log(error);
        loader.close();
        this.showApiError(
          error,
          "Unable to load artworks. Please try again."
        );
      }
    },
  },
  computed: {
    ...mapState("hoc", { shareWork: "shareWork" }),
    ...mapState("auth", { user: "user" }),
  },
  async mounted() {
    await this.getShareWork();
    // console.log(this.shareWork);
  },
};
</script>
<style>
.modal-header {
  display: flex !important;
  align-items: center !important;
  background-color: #4f0a4b !important;
  border-color: #4f0a4b !important;
  padding: 1rem !important;
}
.modal-title {
  font-size: 20px !important;
  color: #fff !important;
}
.textcolor {
  color: #777777 !important;
}
</style>
